import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export function HelpMenu() {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    function onPointerDown(e: PointerEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    }
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  function go(path: string) {
    setOpen(false);
    navigate(path);
  }

  return (
    <div className="topbar-icon-wrap" ref={wrapRef}>
      <button
        type="button"
        className="topbar-icon-btn"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Help"
        title="Help"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.3" />
          <path d="M6.1 6.3a1.9 1.9 0 1 1 2.75 1.7c-.5.27-.85.6-.85 1.15v.35" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <circle cx="8" cy="11.4" r="0.65" fill="currentColor" />
        </svg>
      </button>
      {open && (
        <div className="topbar-dropdown" role="menu" aria-label="Help">
          <div className="topbar-dropdown-title">Need a hand?</div>
          <p className="topbar-dropdown-text">
            CEI Nexus grounds every answer in your project's approved contract documents, with citations you can open
            and verify against the source.
          </p>
          <button type="button" role="menuitem" className="topbar-dropdown-item" onClick={() => go("/ask")}>
            <span className="topbar-dropdown-item-title">Ask CEI Nexus a question</span>
          </button>
          <button type="button" role="menuitem" className="topbar-dropdown-item" onClick={() => go("/messages")}>
            <span className="topbar-dropdown-item-title">Message your project team</span>
          </button>
        </div>
      )}
    </div>
  );
}
